var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 8,
    fill: "#FF6B6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5858L22.2929 10.2929C22.6834 9.90237 23.3166 9.90237 23.7071 10.2929C24.0976 10.6834 24.0976 11.3166 23.7071 11.7071L18.4142 17L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L17 18.4142L11.7071 23.7071C11.3166 24.0976 10.6834 24.0976 10.2929 23.7071C9.90237 23.3166 9.90237 22.6834 10.2929 22.2929L15.5858 17L10.2929 11.7071C9.90237 11.3166 9.90237 10.6834 10.2929 10.2929C10.6834 9.90237 11.3166 9.90237 11.7071 10.2929L17 15.5858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.62730c867cb7b5e45618331562507e56.svg";
export { ForwardRef as ReactComponent };